module.exports = __webpack_public_path__ + "static/media/IMG_3507_sm.20f0a097.jpg";